import '../../../../assets/css/screens/serviceprovider/dashboard/workerprofile/WorkerProfile.css';
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Save, Camera, User } from 'lucide-react';
import axios from 'axios';

const SERVICES = [
  
];

/* ── EditProfileModal ── */
const EditProfileModal = ({ form, onChange, onSave, onClose }) => {
    const baseUrl = "http://localhost:8000/api";
  const navigate = useNavigate();
  const [workerName, setWorkerName] = useState('');
  const [workeremail, setWorkerEmail] = useState('');
  const [workerphoneNumber,setWorkerPhoneNumber] = useState('');
  const [workercnic,setWorkerCnic] = useState('');
  const [workercity,setWorkerCity] = useState('');
  const [professionalTitle,setProfessionalTitle] = useState('');
  const [workeraddress,setWorkerAddress] = useState('');
  const [workerexperience,setWorkerExperience] = useState('');
  const [hourlyRate, setHourlyRate] = useState('');
  const [selectservice, setSelectService] = useState('');
  const [workerProfileImage, setProfileImage] = useState('');
  const [workerBio, setWorkerBio] = useState('');
  const [workerpassword, setWorkerPassword] = useState('');
  const [confirmpassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const fileRef = useRef();

  const handleSignup = () => {
  setLoading(true);

  const formData = new FormData();
  formData.append("workerName", workerName);
  formData.append("workeremail", workeremail);
  formData.append("workerphoneNumber", workerphoneNumber);
  formData.append("workercnic", workercnic);
  formData.append("workercity", workercity);
  formData.append("professionalTitle", professionalTitle);
  formData.append("workeraddress", workeraddress);
  formData.append("workerexperience", workerexperience);
  formData.append("hourlyRate", hourlyRate);
  formData.append("selectservice", selectservice);
  formData.append("workerProfileImage", workerProfileImage);
  formData.append("workerBio", workerBio);
  formData.append("workerpassword", workerpassword);
  formData.append("confirmpassword", confirmpassword );


  axios.post(`${baseUrl}/worker/view`, formData)
  .then(Response => {
    setLoading(false);
    if(Response.data.success){
        localStorage.setItem("workeremail", workeremail);
  localStorage.setItem("workerpassword", workerpassword);
  alert("update successful");
  navigate("/worker-dashboard");
    }
    else{
        alert(Response.data.message);
    }
  })
  .catch((err) => {
    setLoading(false);
    console.log(err);
    alert("server error");
  });
};

const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        alert("Please upload a valid image");
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        alert("Image size must be less than 2MB");
        return;
      }
      setProfileImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };
  //catogories fetch krne k liye

//    useEffect(() => {
//       axios.get(`${baseUrl}/whadmin/viewAllCategory`)
//         .then((response) => {
//           // sirf active categories lao
//           const activeCategories = response.data.category.filter(
//             cat => cat.status === 1 || cat.status === true
//           );
  
//           setCategories(activeCategories);
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     }, []);


  return (
    <div className="wp-modal-overlay" onClick={onClose}>
      <div className="wp-modal" onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="wp-modal__header">
          <h3>Edit Profile</h3>
          <button className="wp-modal__close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="wp-modal__body">

          {/* Avatar */}
          <div className="wp-modal__avatar-wrap">
            <div className="wp-modal__avatar-circle" onClick={() => fileRef.current.click()}>
              {form.avatar
                ? <img src={form.avatar} alt="av" className="wp-modal__avatar-img" />
                : <User size={34} className="wp-modal__avatar-icon" />
              }
              <span className="wp-modal__avatar-cam"><Camera size={13} /></span>
            </div>
            <input
              ref={fileRef}
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleImageUpload }
            />
          </div>

          {/* Fields */}
          {[
            { key: 'name',        label: 'Full Name',         type: 'text'     },
            { key: 'title',       label: 'Profession / Title', type: 'text'    },
            { key: 'phone',       label: 'Phone Number',       type: 'tel'     },
            { key: 'email',       label: 'Email',              type: 'email'   },
            { key: 'cnic',        label: 'CNIC',               type: 'text', placeholder: '35202-1234567-1' },
            { key: 'city',        label: 'City',               type: 'text'    },
            { key: 'location',    label: 'Location',           type: 'text'    },
            { key: 'experience',  label: 'Experience',         type: 'text'    },
            { key: 'hourlyRate',  label: 'Hourly Rate (PKR)',  type: 'number'  },
          ].map(f => (
            <div key={f.key} className="wp-field">
              <label>{f.label}</label>
              <input
                type={f.type}
                value={form[f.key] || ''}
                placeholder={f.placeholder || ''}
                onChange={e => onChange(f.key, e.target.value)}
              />
            </div>
          ))}

          {/* Service */}
          <div className="wp-field">
            <label>Service</label>
            <select
              value={form.service || ''}
              onChange={e => onChange('service', e.target.value)}
              className="wp-field__select"
            >
              {SERVICES.map(s => <option key={s}>{s}</option>)}
            </select>
          </div>

          {/* Password */}
          <div className="wp-field">
            <label>New Password</label>
            <input
              type="password"
              value={form.password || ''}
              placeholder="Leave blank to keep current"
              onChange={e => onChange('password', e.target.value)}
            />
          </div>
          <div className="wp-field">
            <label>Confirm Password</label>
            <input
              type="password"
              value={form.confirmPass || ''}
              onChange={e => onChange('confirmPass', e.target.value)}
            />
          </div>

          {/* Bio */}
          <div className="wp-field">
            <label>Bio</label>
            <textarea
              value={form.about || ''}
              rows={3}
              placeholder="About yourself..."
              onChange={e => onChange('about', e.target.value)}
            />
          </div>

        </div>

        {/* Footer */}
        <div className="wp-modal__footer">
          <button className="wp-modal__cancel" onClick={onClose}>Cancel</button>
          <button className="wp-modal__save" onClick={onSave}>
            <Save size={15} /> Save Changes
          </button>
        </div>

      </div>
    </div>
  );
};

export default EditProfileModal;